import axios from 'axios'
import { searchApi as search, courseApi as course } from '@/config/host'

const searchConfig = {
  baseURL: search,
}
const courseConfig = {
  baseURL: course,
}

const searchApi = axios.create(searchConfig)
const courseApi = axios.create(courseConfig)

export { searchApi, courseApi }
